export default function getStyles() {
    return {
        stepperContainer: {
            width: '100%',
            height: '100%',
            maxHeight: '100%',
            p: '0 16px 16px',
            boxSizing: 'border-box',
        },
        contentContainer: {
            py: '16px',
            height: '50vh',
            boxSizing: 'border-box',
        },
        successScreenContainer: {
            width: '700px',
            textAlign: 'center',
        },
    };
}
